import { render, staticRenderFns } from "./ClinicGrids.vue?vue&type=template&id=5450c247"
import script from "./ClinicGrids.vue?vue&type=script&lang=js"
export * from "./ClinicGrids.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports